// @flow

import React from 'react';
import Providers from '../Providers';
import { mockStoreWithData } from '../../../../mocks/store';
import { MockedNavigationContainer } from '../../../../mocks/navigation';

type MockProvidersProps = {
  children: any,
  store?: Object,
};

export default ({ children, store }: MockProvidersProps) => (
  <Providers store={store || mockStoreWithData}>
    <MockedNavigationContainer component={() => children} />
  </Providers>
);
